
export default function () {

  $('.js-resp-img').each((i, el) => {

    this.loadImage($(el), true);
  });

}
